import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import atividadeSelector from "../store/atividade.selectors";
import solicitacaoSelector from "../../solicitacao/store/solicitacao.selectors";
import atividadeActions from "../store/atividade.actions";
import autoBind from "react-autobind";
import StaticGrid from "@common/components/grid/staticGrid.component";
import * as typeArray from "@/modules/common/app/helpers/grid.typeArray";
import * as messages from "@/modules/common/app/helpers/common.messages";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const options = {
      filterVersion: Math.random(),
      noStorage: true,
      webStorage: "Deca.Atividades",
      applySearchOnLoad: true
    };

    const columns = [
      {
        fieldName: "Código",
        dataName: "CodigoString",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Descrição",
        dataName: "Descricao",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Principal",
        dataName: "Principal",
        show: true,
        array: typeArray.tipoSimNaoInt,
        type: "lista",
        arrayType: "text",
        removeFilter: true
      }
    ];

    const actions = [
      {
        title: "Tornar principal",
        icon: "fas fa-check",
        onClick: async dataItem => {
          const {
            TipoSolicitacao,
            SituacaoSolicitacao
          } = this.props.solicitacaoSelector.solicitacao;
          if (TipoSolicitacao == "3")
            _showError(
              "Este registro não pode ser modificado durante o processo de Encerramento."
            );
          else if (
            SituacaoSolicitacao != "Aguardando Avaliação" &&
            SituacaoSolicitacao != 1 &&
            SituacaoSolicitacao != 2
          )
            _showError("Este registro não pode ser modificado.");
          else await this.props.atividadeActions.mainSagaAtividade(dataItem);
        }
      },
      {
        type: "delete",
        onClick: async dataItem => {
          const {
            TipoSolicitacao,
            SituacaoSolicitacao
          } = this.props.solicitacaoSelector.solicitacao;
          if (TipoSolicitacao == "3")
            _showError(
              "Este registro não pode ser excluído durante o processo de Encerramento."
            );
          else if (
            SituacaoSolicitacao != "Aguardando Avaliação" &&
            SituacaoSolicitacao != 1 &&
            SituacaoSolicitacao != 2
          )
            _showError("Este registro não pode ser modificado.");
          else if(this.props.desabilitaExclusao)
            _showError("Este registro não pode ser excluído pois está vinculado com o CNAE associado.");
          else {
            const result = await _alert.confirm(
              messages.CONFIRMA_DELETE,
              "Remover Registro Selecionado"
            );
            if (result)
              this.props.atividadeActions.deleteSagaAtividade(dataItem);
          }
        }
      }
    ];

    const order = [
      { fieldName: "Código", dataName: "CodigoString", order: "A" }
    ];

    const toolbar = {
      title: "",
      prefix: " ",
      tools: {
        limpar: false
      }
    };

    this.config = {
      order,
      columns,
      actions,
      options,
      toolbar
    };
  }

  render() {
    const { atividade } = this.props.atividadeSelector;
    const { atividades } = atividade;
    const { isView } = this.props;
    if (isView) this.config.actions = [];

    return (
      <StaticGrid {...this.config} itens={atividades.asMutable()}></StaticGrid>
    );
  }
}

export default connect({
  actions: {
    atividadeActions
  },
  selectors: {
    solicitacaoSelector,
    atividadeSelector
  }
})(Container);
